'use strict';

export default class BarChart {
  constructor(d3, id, dataset, data1, data2) {
    const width = 400;
    const height = 200;

    const margin = {
      top: -1,
      right: 0,
      bottom: 40,
      left: -1
    };

    const groupKey = 'time';
    const keys = ['handleTimeAvg', 'handleTimePersonal'];

    const x0 = d3
      .scaleBand()
      .domain(dataset.map(d => d[groupKey]))
      .rangeRound([margin.left, width - margin.right])
      .paddingInner(0.5);

    const x1 = d3
      .scaleBand()
      .domain(keys)
      .rangeRound([0, x0.bandwidth()])
      .padding(0);

    const y = d3
      .scaleLinear()
      .domain([0, d3.max(dataset, d => d3.max(keys, key => d[key]))])
      .nice()
      .rangeRound([height - margin.bottom, margin.top]);

    const color = d3.scaleOrdinal().range([data1.color, data2.color]);

    const xAxis = g =>
      g
        .attr('transform', `translate(0,${height - margin.bottom})`)
        .call(g => g.select('.domain').remove())
        .call(d3.axisBottom(x0).tickFormat(hr => (hr > 12 ? `${hr - 12}pm` : `${hr}am`)));

    const yAxis = g =>
      g
        .attr('transform', `translate(${margin.left},0)`)
        .call(d3.axisLeft(y).ticks(null, 's'))
        .call(g => g.select('.domain').remove())
        .call(g =>
          g
            .select('.tick:last-of-type text')
            .clone()
            .attr('x', 3)
            .attr('text-anchor', 'start')
            .attr('font-weight', 'bold')
            .text(dataset.y)
        )
        .attr('class', 'graph-axis')
        .call(
          d3
            .axisLeft(y)
            .tickFormat('')
            .tickSize(-width)
        );

    const tooltip = d3
      .select(id)
      .append('div')
      .attr('class', 'graph-tooltip')
      .style('opacity', 0);

    const svg = d3
      .select(id)
      .append('svg')
      .attr('width', width)
      .attr('height', height);

    svg
      .append('g')
      .selectAll('g')
      .data(dataset)
      .join('g')
      .attr('class', 'graph-group')
      .on('mouseover', d => {
        tooltip
          .transition()
          .duration(200)
          .style('opacity', 0.9);
        tooltip.html(`
          <div class="graph-tooltip-primary">
              ${data1.lbl}: ${d.handleTimePersonal}
          </div>
          <div class="graph-tooltip-secondary">
              ${data2.lbl}: ${d.handleTimeAvg}
          </div>
        `);
      })
      .on('mouseout', d => {
        tooltip
          .transition()
          .duration(1000)
          .style('opacity', 0);
      })
      .attr('transform', d => `translate(${x0(d[groupKey])},0)`)
      .selectAll('rect')
      .data(d => keys.map(key => ({ key, value: d[key] })))
      .join('rect')
      .attr('x', d => x1(d.key))
      .attr('y', d => y(d.value))
      .attr('width', x1.bandwidth())
      .attr('height', d => y(0) - y(d.value))
      .attr('fill', d => color(d.key));

    svg
      .append('g')
      .call(xAxis)
      .selectAll('text')
      .attr('transform', 'rotate(45)')
      .style('text-anchor', 'start');

    svg.append('g').call(yAxis);
  }
}
